const RFIDPaymentMethod = {
  PesoBalance: "peso-balance",
  Card: "card",
};

export default RFIDPaymentMethod;
